import React from "react";
import { Route } from "react-router-dom";
import dayjs from 'dayjs';
import { DATE_FORMAT } from "../variables/constants";
import { API_NAME } from "../constants";

export  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].secondary;
      }
    }
    return false;
  };
export const filterRoutes = (routes, userLevel, moduleRights, layout="/console") => {
  return routes
    .filter(route =>
      route.path !== "sign-in" &&
      route.layout === layout &&
      route.level >= userLevel && 
	  (route.moduleId === 0 || moduleRights?.some(module => module.module_id === route.moduleId))
    )
    .map(route => ({
      ...route,
      children: Array.isArray(route.children)
        ? filterRoutes(route.children, userLevel, moduleRights, layout)
        : undefined
    }));
};

export const getRoutes = (routes, layout="/console") => {
  return routes
	.filter((route) => route.path !== "sign-in")
	.map((prop, index) => {
	  if (prop.layout === layout) {
		return (			
		  <React.Fragment key={`${prop.path}-${index}`}>
			<Route path={prop.path.startsWith('/') ? prop.path : `/${prop.path}`} element={prop.component} />
			{Array.isArray(prop.children) && getRoutes(prop.children)}
		  </React.Fragment>
		);
	  } else {
		return null;
	  }
	});
};

export const getActiveRoute = (routes, pathname) => {
    routes.forEach((route) => {
      if (`${route.layout}/${route.path}` === pathname) {
        document.title = `${API_NAME} - ${route.name}`;
      } else if (route.children) {
        route.children.forEach((child) => {
          if (`${route.layout}/${child.path}` === pathname) {
            document.title = `${API_NAME} - ${child.name}`;
          }
        });
      }
    });
};

export const NumberFormatter = (number, decimal=2) => {	
	return number !== undefined 
    ? parseFloat(number).toFixed(decimal).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : '';
};

export const FormatDateValue = (date) => {
	return date ? dayjs(date, DATE_FORMAT) : null;
}

export const handleTableChange = (doSearch, filters) => (pagination, tableFilters, sorter) => {
  const columnFilters = Object.fromEntries(
    Object.entries(tableFilters).map(([key, value]) => [
      key, 
      value ? value.join(', ') : '',
    ])
  );

  const sorting = sorter.field ? {
    sortby: sorter.field, 
    sortorder: sorter.order === 'descend' ? 'desc' : 'asc',
  } : {};

  doSearch({
    ...filters,
    paginate: pagination.pageSize,
    page: pagination.current,
    ...sorting,
    ...columnFilters,
  });
};

export const generateCRUDRoutes = ({
	mainTitle, 
	basePath, 
	mainComponent, 
	layout, 
	icon, 
	subTitle, 
	viewComponent, 
	createComponent, 
	editComponent,
	isMainMenu=true, 
	submodules=[],
	viewSubmodules=[],
	level=4,
	moduleId=0,
	}) => {
		
	const pathSegments = basePath.split('/');	
	const recordId = `${pathSegments[pathSegments.length - 1].replace(/-/g, '').slice(0, -1)}Id`;
	return {
		name: `${mainTitle}`,
		path: `${basePath}`,
		component: mainComponent,
	    layout,	    
	    icon,	    
	    isMainMenu,
		level,
		moduleId,
	    children: [
		  {
		    name: `${subTitle} Details`,
		    layout: layout,
		    path: `${basePath}/:${recordId}/view`,
		    component: viewComponent,
		    isMainMenu: false,
			level,
			moduleId,
		    children: [
				...viewSubmodules,
			],
		  },
		  {
		    name: `Add ${subTitle}`,
		    layout: layout,
		    path: `${basePath}/add`,
		    component: createComponent,
		    isMainMenu: false,
			level,
			moduleId,
		  },
		  {
		    name: `Edit ${subTitle}`,
		    layout: layout,
		    path: `${basePath}/:${recordId}/edit`,
		    component: editComponent,
		    isMainMenu: false,
			level,
			moduleId,
		  },
		  ...submodules,
		]
	}
};

export const displayFullName = (data, lastNameFirst=true) => {	
	let fullName = '';
	if(lastNameFirst){
		fullName = data?.last_name && data?.last_name !== '' ? data?.last_name + ', ' : '';
		fullName += data?.first_name && data?.first_name !== '' ? data?.first_name + ' ' : '';
		fullName += data?.middle_name && data?.middle_name !== '' ? data?.middle_name : '';
	}else{		
		fullName = data?.first_name && data?.first_name !== '' ? data?.first_name+ ' ' : '';
		fullName += data?.middle_name && data?.middle_name !== '' ? data?.middle_name + ' ' : '';
		fullName += data?.last_name && data?.last_name !== '' ? data?.last_name : '';
	}
	return fullName.trim();
};

export const displayAddress = (address) => {	
	let fullAddress = address?.address_line1 && address?.address_line1 !== '' ? address?.address_line1 : '';
	fullAddress += address?.address_line2 && address?.address_line2 !== '' ? `, ${address?.address_line2}` : '';
	fullAddress += address?.barangay && address?.barangay !== '' ? `, ${address?.barangay}` : '';
	fullAddress += address?.municipality && address?.municipality !== '' ? `, ${address?.municipality}` : '';
	fullAddress += address?.province && address?.province !== '' ? `, ${address?.province}` : '';
	fullAddress += address?.region && address?.region !== '' ? `, ${address?.region}` : '';

	return fullAddress.trim();
};

export const displayFarmNameLocation = (farm) => {	
	let farmLocation = '';
	if(farm){
		farmLocation = `${farm.name} / ${farm.location_barangay}, ${farm.location_municipality}`;
	}

	return farmLocation.trim();
};

export const renderLabel = (value, className) => <label className={`ps-3 dark:text-white ${className}`}>{value || ''}</label>;

export const selectSearchFilter = (input, option) => {
	return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
}

export const getAnimalTypeRoute = (typeId) => {
	const routes = {
		10: 'carabaos',
		11: 'cattles',
		12: 'goats',
		13: 'sheeps',
		14: 'swines',
	};


	return routes[typeId] || '/unknown';
}